/** Labels for situation-specific short errors (keys must match backend clientReasonCode). */

export const CHECKIN_REASON_ROWS: { code: string; label: string }[] = [
	{ code: 'CHECKIN_ALREADY_CHECKED_IN', label: 'Already checked in (same shift window)' },
	{ code: 'CHECKIN_SHIFT_ALREADY_COMPLETED', label: 'Shift already finished (in and out)' },
	{ code: 'CHECKIN_STAFF_NOT_FOUND', label: 'Staff profile not found' },
	{ code: 'CHECKIN_STAFF_INACTIVE', label: 'Staff account inactive' },
	{ code: 'CHECKIN_NOT_NIGHT_SHIFT', label: 'Not on night shift' },
	{ code: 'CHECKIN_SHIFT_NOT_FOUND', label: 'Shift assignment missing' },
	{ code: 'CHECKIN_CHECKOUT_PREVIOUS_SHIFT_FIRST', label: 'Must check out previous shift first' },
	{ code: 'CHECKIN_ABSENT_SHIFT_ENDED', label: 'Absent — shift ended' },
	{ code: 'CHECKIN_SHIFT_ENDED_CONTACT_ADMIN', label: 'Shift ended — contact admin' },
	{ code: 'CHECKIN_SYSTEM_INVALID_FLAGS', label: 'Internal validation error' },
	{ code: 'CHECKIN_AFTER_SHIFT_END', label: 'After shift end — cannot check in' },
	{ code: 'CHECKIN_TOO_EARLY', label: 'Too early to check in' },
	{ code: 'CHECKIN_TOO_LATE', label: 'Too late to check in' },
	{ code: 'CHECKIN_LATE_NEED_REASON', label: 'Late — reason required' },
	{ code: 'CHECKIN_GEOFENCE_ORG_NOT_FOUND', label: 'Geofence: org config missing' },
	{ code: 'CHECKIN_GEOFENCE_OFFICE_NOT_CONFIGURED', label: 'Geofence: office GPS not set' },
	{ code: 'CHECKIN_GEOFENCE_TOO_FAR', label: 'Geofence: too far from office' },
	{ code: 'CHECKIN_INVALID_SHIFT_HANDLER', label: 'Invalid shift handler (config)' },
	{ code: 'CHECKIN_SCHEDULE_GROUP_MISMATCH', label: 'Schedule group ≠ your assignment' },
	{ code: 'CHECKIN_SCHEDULE_LOOKUP_FAILED', label: 'Could not load schedule for today' },
	{ code: 'CHECKIN_NEXT_DAY_SCHEDULE_FAILED', label: 'Could not load next-day schedule' },
	{ code: 'CHECKIN_SCHEDULE_SERVICE_ERROR', label: 'Schedule service error' },
	{ code: 'CHECKIN_NO_SCHEDULE_FOR_DATE', label: 'No schedule row for this date' },
	{ code: 'CHECKIN_NOT_IN_GROUP_ROSTER', label: 'Not on group roster / out of shift' },
	{ code: 'CHECKIN_SHIFT_CONFIG_INCOMPLETE', label: 'Shift times incomplete in config' },
	{ code: 'CHECKIN_ALL_SHIFTS_COMPLETE_TODAY', label: 'All today’s shifts already done' },
]

export const CHECKOUT_REASON_ROWS: { code: string; label: string }[] = [
	{ code: 'CHECKOUT_NO_ACTIVE_CHECKIN', label: 'No check-in for today' },
	{ code: 'CHECKOUT_NO_ACTIVE_CHECKIN_EXTENDED', label: 'No check-in (incl. yesterday path)' },
	{ code: 'CHECKOUT_SYSTEM_INVALID_FLAGS', label: 'Internal validation error' },
	{ code: 'CHECKOUT_ALREADY_CHECKED_OUT', label: 'Already checked out' },
	{ code: 'CHECKOUT_BEFORE_CHECKIN_TIME', label: 'Check-out before check-in time' },
	{ code: 'CHECKOUT_WAY_PAST_SHIFT_END', label: 'Far past shift end — manual close' },
	{ code: 'CHECKOUT_TOO_EARLY', label: 'Too early to check out' },
	{ code: 'CHECKOUT_EARLY_NEED_REASON', label: 'Early check-out — reason required' },
	{ code: 'CHECKOUT_TOO_LATE', label: 'Too late to check out' },
	{ code: 'CHECKOUT_GEOFENCE_ORG_NOT_FOUND', label: 'Geofence: org config missing' },
	{ code: 'CHECKOUT_GEOFENCE_OFFICE_NOT_CONFIGURED', label: 'Geofence: office GPS not set' },
	{ code: 'CHECKOUT_GEOFENCE_TOO_FAR', label: 'Geofence: too far from office' },
]
